import { render, staticRenderFns } from "./Static-display.vue?vue&type=template&id=18c0dea6"
import script from "./Static-display.vue?vue&type=script&lang=js"
export * from "./Static-display.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports